/**
 * This is a set of common keywords defined by business side.
 * It only acts as a shortcut for inputting keywords, so can be changed
 * at any time without consequence to the function of the tool.
 */
export const COMMON_KEYWORDS = [
  "観光",
  "旅行",
  "観光旅行",
  "観光地",
  "観光施設",
  "遊覧",
  "見物",
  "観光名所",
  "観光案内所",
  "名所",
  "公園",
  "記念公園",
  "国立公園",
  "公立公園",
  "自然公園",
  "自然動物公園",
  "運動公園",
  "ランチ",
  "昼食",
  "レストラン",
  "アイスクリーム店",
  "居酒屋",
  "バー",
  "朝食",
  "カフェ・喫茶",
  "スイーツ店",
  "コーヒー ショップ",
  "店",
  "お店",
  "アウトレット",
  "ギフト",
  "ショッピング",
  "モール",
  "ショッピング モール",
  "デパート",
  "お土産",
  "百貨店",
  "ホテル",
  "旅館",
  "カプセルホテル",
  "ゲスト ハウス",
  "ビジネス ホテル",
  "ユース ホステル",
  "ロッジ",
  "温泉旅館",
  "高級ホテル",
  "民宿",
  "ウォーター パーク",
  "テーマ パーク",
  "ホリデー パーク",
  "遊園地",
  "水族館",
  "動物園",
  "美術館",
  "ギャラリー",
  "博物館",
  "キャンプ",
  "農園",
  "科学博物館",
  "温泉",
  "日帰り温泉",
  "サウナ",
  "スパ リゾート",
  "サウナ・スパ",
  "カヌー/カヤックツアー代理店",
  "ゴルフ場",
  "スキー場"
];
